// extracted by mini-css-extract-plugin
export var background = "_5p-0";
export var container = "_5p-1";
export var contentItem = "_5p-7";
export var extendedWarranty = "_5p-5";
export var link = "_5p-d";
export var modal = "_5p-b";
export var modalCloseButton = "_5p-9";
export var modalContent = "_5p-3";
export var modalContentMain = "_5p-6";
export var modalImageLogo = "_5p-8";
export var modalLogo = "_5p-a";
export var modalSideImage = "_5p-4";
export var preview = "_5p-c";
export var redoModal = "_5p-2";